import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DehazeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dehaze"}/>
}
